<template>

        <div>
            <div class="control-header">
                <logo/>
                <ChangeModel/>
                <div style="position: absolute;right:20px;float:left;">
                    <header-search class="header-item"/>
                </div>
            </div>
            <div style="position: absolute;width: 230px;top:50px;left:0;bottom: 0;background-color: #333743;padding-top: 10px">
                <a-menu
                        :selectedKeys="defaultSelectedKeys"
                        mode="inline"
                        theme="dark"
                        @click="menuClick"
                >
                    <template v-for="item in list">
                        <a-menu-item v-if="!item.children" :key="item.key">
                            <a-icon :type="item.ico"/>
                            <span>{{item.title}}</span>
                        </a-menu-item>
                        <sub-menu v-else :menu-info="item" :key="item.key"/>
                    </template>
                </a-menu>
            </div>
            <div class="control-content">
                <router-view @setMenu="setMenu"/>
            </div>

        </div>

</template>

<script>
    import logo from '../components/Logo'
    import HeaderSearch from '../components/HeaderSearch'
    import ChangeModel from '../components/ChangeModel'
    import SubMenu from '../components/SubMenu'

    export default {
        components: {
            logo,
            ChangeModel,
            HeaderSearch,
            'sub-menu': SubMenu,
        },
        data(){
            return {
                breadcrumb: [],
                defaultSelectedKeys:[],
                list: [],
            }
        },
        mounted () {
            this.getBreadcrumb()
            setInterval(()=>{
                this.resfreshToken()
            },300000)
        },
        updated () {
            this.getBreadcrumb()
        },
        methods:{
            resfreshToken(){
                let token = window.localStorage.getItem('token')
                this.$http.post('/oauth/refreshtoken',{token:token})
                    .then(res=>{
                        if (res.data.state == 200) {
                            window.localStorage.setItem('token', res.data.data.token);
                            console.log('token resfresh')
                        }
                    })
            },
            setMenu(data){
                this.list = data['list']
                this.defaultSelectedKeys = data['defaultSelectedKeys']
            },
            getBreadcrumb () {
                this.breadcrumb = this.$route.matched
            },
            menuClick(e){
                const path = this.$route.matched[this.$route.matched.length - 2].path + '/' + e.keyPath.reverse().join('/')
                this.$router.push(path)
                // this.current = e.key
            },
            onOpenChange (openKeys) {
                const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1)
                if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
                    this.openKeys = openKeys
                } else {
                    this.openKeys = latestOpenKey ? [latestOpenKey] : []
                }
            },

        }
    }
</script>

<style scoped>
    .control-header {position: absolute; left: 0; top: 0; right: 0; z-index: 1; height: 50px; background: #fff; color: #fff; background-image: linear-gradient(90deg,#4157E8,#8E9AE8); display: flex; align-items: center;}

    .control-content { position: absolute; top: 50px; left: 230px; right: 0; bottom: 0; background: #f0f2f5; overflow-x: hidden;}

</style>
